import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { of as observableOf, Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { SymptomsService } from './symptoms.service';
import { BaseService } from '../../shared/base.service';
import { BaseComponent } from '../../shared/base.component';
import { SymptomsModel } from './symptoms.model';
import { AppService } from '../../app.service';
import { DialogComponent } from '../../dialog/dialog.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Component({
    selector: 'symptoms-component',
    templateUrl: './symptoms.component.html',
    styleUrls: ['./symptoms.component.scss'],
    providers: [SymptomsService, BaseService]
})

export class SymptomsComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('dialogLogo', {static: false}) dialogLogo: DialogComponent;
    @ViewChild('modalDeleteSymptom', {static: false}) modalDeleteSymptom: ModalDirective;

    helpSymptomProfile: any;
    readonly tableColumns = [
        ['feeling_system_id', 'ID', 'col-xs-1 id-header', 'customer_id', 'default'],
        ['symptom_name_', 'Symptom Name', 'col-xs-3 name-header', 'name', 'translation', 'DE'],
        ['feeling_name_', 'Feeling name', 'col-xs-3 name-header', 'name', 'translation', 'DE'],
        ['domain_name_', 'Domain', 'col-xs-2 domain-header', 'name', 'translation', 'EN'],
        ['standard', 'Standard', 'col-xs-1 standard-col', 'translation', 'default', 'EN'],
        ['in_self_rating', 'In self rating', 'col-xs-1 scientific-header', 'scientific', 'boolean'],
        ['acute_anamnestic', 'Acute/Anamnestic', 'col-xs-1 acute-col', 'translation', 'default'],
    ];

    formLoading = true;
    items: any;
    deletingSymptom: any;
    parentItem = 0;
    filterByDomain: any;
    item: any;
    indicatorsReference: any;
    symptoms: any;
    domains: any;
    neutral_system_ids: any;
    symptomsByDomain: any;
    standards: any;
    genders: any;
    coordinate: any;
    itemLanguage: string;

    constructor(public authService: AuthService,
                public router: Router,
                public baseService: BaseService,
                public appService: AppService,
                public route: ActivatedRoute,
                public translate: TranslateService,
                public fb: FormBuilder,
                public symptomsService: SymptomsService) {
        super(authService, router, baseService, appService);
    }

    ngOnInit() {
        super.itemsPerPage = 20;
        super.ngOnInit();
        this.itemLanguage = 'de_CH';
        this.sortedColumn = 'symptom_name_' + this.itemLanguage;
        this.searchInfo = new SymptomsModel();
        this.url = 'self-report-setting/feelings';
        this.token = this.authService.user['token'];
        this.languages = JSON.parse(localStorage.getItem('languages'));
    }

    ngAfterViewInit(): void {
        switch (this.params['action']) {
            case 'create': {
                this.openFormModal({action: 'create', component: 'symptom', title: 'Add Symptom', url: this.url});
                break;
            }
            case 'update': {
                this.openFormModal({
                    action: 'update',
                    component: 'symptom',
                    feeling_system_id: this.params['symptom_system_id'],
                    title: 'Edit Symptom',
                    url: this.url
                });
                break;
            }
            case 'read': {
                this.openFormModal({
                    action: 'read', feeling_system_id: this.params['feeling_system_id'], title: 'Symptom Details',
                    content: this.params['content'], description: this.params['description'], url: this.url
                });
                break;
            }
            case 'activate':
            case 'delete' : {
                this.params['url'] = this.url;
                this.openConfirmModal(this.params);
                break;
            }
            default: {
                this.getItems();
                break;
            }
        }
    }

    // handle add buton clicks
    openFormModal(params: Object) {
        this.initForm(params);
        this.symptomsService.read(this.url, params['id'] || params['feeling_system_id'])
            .subscribe(response => {
                this.item = response['data'];
                // add new variable for Neutral name

                this.symptoms = response['symptoms'];
                this.domains = response['domains'];
                this.neutral_system_ids = response['neutral_system_ids'];
                let symptomsByDomain = this.symptoms;
                if(response['data']['domain_id']){
                    symptomsByDomain = _.filter(this.symptoms, function(item){
                        return (item['domain_id'] === response['data']['domain_id']);
                    });
                }
                this.symptomsByDomain = symptomsByDomain;
                this.standards = response['standards'];
                this.indicatorsReference = response['indicator_reference_ids'];


                let form = {};
                let disabled = params['action'] === 'read' ? true : false;

                // Add more custom field
                // form['symptom_neutral_name_' + this.itemLanguage] = {value: this.item['symptom_neutral_name_' + this.itemLanguage], disabled: this.item['hasNeutral'] };
                this.coordinate = this.item['symptom_svg_' + this.itemLanguage] ? JSON.parse(this.item['symptom_svg_' + this.itemLanguage]) : {};
                this.item['coordinate_x_' + this.itemLanguage] = this.coordinate.x;
                this.item['coordinate_y_' + this.itemLanguage] = this.coordinate.y;
                this.item['text_placement_' + this.itemLanguage] = this.coordinate.text_placement;

                for (let column in this.item) {
                    if (this.item.hasOwnProperty(column)) {
                        form[column] = {value: this.item[column], disabled: disabled};
                    }
                }


                if (this.form != null) {
                    this.form.reset(form);
                }
                this.form = this.fb.group(form);
                this.form.controls['feeling_name_' + this.itemLanguage].setValidators([<any>Validators.required, <any>Validators.minLength(3)]);
                this.form.controls['feeling_name_on_map_' + this.itemLanguage].setValidators([<any>Validators.required, <any>Validators.minLength(3)]);
                this.form.controls['domain_id'].setValidators([<any>Validators.required, <any>Validators.min(1)]);
                this.form.controls['symptom_name_' + this.itemLanguage].setValidators([<any>Validators.required, <any>Validators.minLength(3)]);
                this.form.controls['symptom_name_on_map_' + this.itemLanguage].setValidators([<any>Validators.required, <any>Validators.minLength(3)]);

                if (params['action'] === 'create') {
                    this.form.controls['is_acute'].setValue(1);
                    this.form.controls['symptom_system_id'].setValue(-1);
                }

                this.showModal();
            });
    }

    initForm(params: Object) {
        this.formSubmitted = false;
        super.initForm(params, false);
    }

    setData(data: any): void {
        this.items = data.items;
        if (data.domains != null) {
            this.filters = [data.domains];
            this.filterByDomain = data.domains;
        }
        this.totalItems = data.total || data.items.length;
        // if users are empty, hide the page numbers below the users list to prevent page redirection
        this.paginationHidden = this.items.length === 0;
        this.isLoading = false;
    }

    deleteSymptom(symptom) {
        this.deletingSymptom = symptom;
        this.modalDeleteSymptom.show();
    }

    // user addition/update handler: send user info to DB
    submit(model: any, isValid: boolean, url?: string, isUpdated?: boolean): void {
        // Refactor coordinate before submit data
        this.coordinate.x = this.form.controls['coordinate_x_' + this.itemLanguage].value;
        this.coordinate.y = this.form.controls['coordinate_y_' + this.itemLanguage].value;
        this.coordinate.text_placement = this.form.controls['text_placement_' + this.itemLanguage].value;
        this.form.controls['symptom_svg_' + this.itemLanguage].setValue(JSON.stringify(this.coordinate));
        if(this.form.controls['is_indicator'].value === 0){
            this.form.controls['indicator_reference_id'].setValue(null);
        }

        return super.submit(this.form.value, this.form.valid, this.url, true);
    }

    submitDeleteSymptom() {
        this.isLoading = true;
        this.symptomsService.deleteSymptom(this.url, this.deletingSymptom).subscribe(res => {

            if (res['success']) {
                this.modalDeleteSymptom.hide();
                this.modal.hide();
                this.isUpdated = true;
                this.isLoading = false;
                this.getItems();

                const message = res['message'];
                if (message) {
                    const alert = this.dialog.openAlert({icon: 'far fa-trash-alt'});
                    alert.showAlert(message);
                }
            } else {
                const message = res['error'];
                if (message) {
                    const alert = this.dialog.openAlert({icon: 'fas fa-exclamation-triangle'});
                    alert.showAlert(message);
                }
            }
        });
    }

    hideModal() {
        this.modal.hide();
    }

    sort(column) {
        let field = column['0'];
        if (column[3] === 'name') {
            field = field + this.itemLanguage;
        }
        super.sort(field);
    }

    filterLanguage(lang){
        this.itemLanguage = lang;
        // return this.setFilter(lang, 'language');
    }

    switchLanguage(lang){
        this.itemLanguage = lang;
    }
}
